import * as actionTypes from './actionTypes';

export const initDeviceGroupsStart = () => {
  return {
    type: actionTypes.INIT_DEVICE_GROUPS_START
  };
};
export const resetDeviceGroupsState = () => {
  return {
    type: actionTypes.RESET_DEVICE_GROUPS_STATE,

  };
}
export const setDeviceGroups = (data) => {
  //console.log('setDevicegroups actions', data);
  return {
    type: actionTypes.SET_DEVICE_GROUPS,
    deviceGroups: data
  };
};

export const fetchDeviceGroupsFailed = () => {
  return {
    type: actionTypes.FETCH_DEVICE_GROUPS_FAILED
  };
};

export const initDeviceGroups = () => {
  return {
    type: actionTypes.INIT_DEVICE_GROUPS
  };
};

export const createDeviceGroup = (deviceGroup) => {
  //console.log("actions.createDeviceGroup");
  return {
    type: actionTypes.CREATE_DEVICE_GROUP,
    deviceGroup: deviceGroup
  };
};

export const createDeviceGroupStart = () => {
  //console.log("actions.createDeviceGroupStart");
  return {
    type: actionTypes.CREATE_DEVICE_GROUP_START
  };
};

export const createDeviceGroupFailed = () => {
  //console.log("actions.createDeviceGroupFailed");
  return {
    type: actionTypes.CREATE_DEVICE_GROUP_FAILED
  };
};

export const createDeviceGroupSuccess = () => {
  //console.log("actions.createDeviceGroupSuccess");
  return {
    type: actionTypes.CREATE_DEVICE_GROUP_SUCCESS
  };
};

export const resetCreateDeviceGroupSuccessError = () => {
  //console.log("actions.resetCreateDeviceGroupSuccessError");
  return {
    type: actionTypes.RESET_CREATE_DEVICE_GROUP_SUCCESS_ERROR
  };
};

export const resetPauseDeviceGroupSuccessError = () => {
  //console.log("actions.resetCreateDeviceGroupSuccessError");
  return {
    type: actionTypes.RESET_PAUSE_DEVICE_GROUP_SUCCESS_ERROR
  };
};

export const getDevicesFromGroup = (deviceGroup) => {
  //console.log("actions.getDevicesFromGroup");
  return {
    type: actionTypes.GET_DEVICES_FROM_GROUP,
    deviceGroup: deviceGroup
  };
};

export const getDevicesFromGroupStart = () => {
  //console.log("actions.getDevicesFromGroupStart");
  return {
    type: actionTypes.GET_DEVICES_FROM_GROUP_START
  };
};

export const getDevicesFromGroupFailed = () => {
  //console.log("actions.getDevicesFromGroupFailed");
  return {
    type: actionTypes.GET_DEVICES_FROM_GROUP_FAILED
  };
};

export const deleteGroup = (deviceGroupId) => {
  return {
    type: actionTypes.DELETE_GROUPS,
    deviceGroupId
  }
}

export const deleteGroupFailed = () => {
  return {
    type: actionTypes.DELETE_GROUPS_FAILED
  }
}

export const deleteGroupSucess = () => {
  return {
    type: actionTypes.DELETE_GROUPS_SUCCESS
  }
}

export const changeDeviceGroupDetails = (data) => {
  // console.log('Coming into Actions');
  // console.log(data);
  //console.log("testing Api", deviceGroupName,deviceGroupIcon,deviceGroupId);
  return {
    type: actionTypes.CHANGE_DEVICE_GROUP_DETAILS,
    deviceGroupName: data.grpName,
    deviceGroupIcon: data.grpIcon,
    deviceGroupId: data.grpId,
    groupPrimaryDevice: data.grpPrimaryDevice,
    groupAssignedDevices: data.grpAssignedDevices,
    pathType: data.type

  };
}

export const changeDevicesGroupFailed = () => {
  return {
    type: actionTypes.CHANGE_DEVICES_GROUP_FAILED
  }
}

export const changeDevicesGroupSuccess = () => {
  return {
    type: actionTypes.CHANGE_DEVICES_GROUP_SUCCESS
  }
}

export const createGroupPauseSchedule = (data) => (
  {
    type: actionTypes.CREATE_GROUP_PAUSE_SCHEDULE,
    isScheduleEnabled: data.isSchedule,
    deviceGroupId: data.deviceGroupId,
    templateId: data.templateId,
    template: data.template,
  }
)

export const deleteGroupPauseSchedule = (data) => (
  {
    type: actionTypes.DELETE_GROUP_PAUSE_SCHEDULE,
    deviceGroupId: data.deviceGroupId,
    templateId: data.templateId,
    template: data.template,
  }
)

export const pauseDeviceGroup = (data) => {
  return {
    type: actionTypes.PAUSE_DEVICE_GROUP,
    isSchedule: data.isSchedule,
    deviceGroupId: data.deviceGroupId,
    templateId: data.templateId,
    template: data.template,
    action: data.action
  };
}

export const freezeDeviceGroup = (data) => {
  return {
    type: actionTypes.FREEZE_DEVICE_GROUP,
    deviceGroupId: data.deviceGroupId
  };
}

export const freezeDevicesGroupSuccess = () => {
  return {
    type: actionTypes.FREEZE_DEVICE_GROUP_SUCCESS
  };
}
export const freezeDevicesGroupFailed = () => {
  return {
    type: actionTypes.FREEZE_DEVICE_GROUP_FAILED
  };
}

export const pauseDeviceGroupFailed = () => {
  return {
    type: actionTypes.PAUSE_DEVICE_GROUP_FAILED
  }
}

export const pauseDeviceGroupSuccess = () => {
  return {
    type: actionTypes.PAUSE_DEVICE_GROUP_SUCCESS
  }
}

export const resetGroupsErrorSuccess = () => {

  return {
    type: actionTypes.RESET_GROUPS_ERROR_SUCCESS
  }
}

export const unassignDeviceGroup = (deviceGroupId, deviceMacs) => {
  return {
    type: actionTypes.UNASSIGN_DEVICE_GROUPS,
    deviceGroupId: deviceGroupId,
    deviceMacs: deviceMacs
  }
}

export const unassignDeviceGroupFailed = () => {
  return {
    type: actionTypes.UNASSIGN_DEVICE_GROUPS_FAILED
  }
}

export const unassignDeviceGroupSucess = () => {
  return {
    type: actionTypes.UNASSIGN_DEVICE_GROUPS_SUCCESS
  }
}

export const resetDeviceGroupSuccessError = () => ({ type: actionTypes.RESET_PAUSE_DEVICE_GROUP_SUCCESS_ERROR });
